// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2DaBq","actions":"GroupTable_actions__EGKfd","deleteModalFooter":"GroupTable_deleteModalFooter__2fTP1"};